import { IResources } from "../../models/ITranslationResources";
import { Locale } from "./Locale";

export abstract class ITranslator {
  abstract changeLanguage(language: Locale): void;
  abstract getLanguageSet(): IResources;
  abstract translate(text: string): string;
  abstract init(): void;
}
